export const TIME_TO_STALE = 5 * 60 * 1000;

export const REQUEST_TYPES = {
  GET: "GET",
  POST: "POST",
  DELETE: "DELETE",
  PUT: "PUT"
};

export const CONTENT_TYPE = {
  JSON: "application/json",
  JSON_CHARSET: "application/json; charset=utf-8",
  JSON_LD: "application/ld+json",
  JSON_LD_CHARSET: "application/ld+json; charset=utf-8",
  JSON_PROBLEM: "application/problem+json",
  JSON_PROBLEM_CHARSET: "application/problem+json; charset=utf-8",
  PROPERTIES: "text/plain; charset=utf-8",
  OCTET_STREAM: "application/octet-stream",
  PDF: "application/pdf",
  PDF_CHARSET: "application/pdf; charset=utf-8",
  TXT: "text/plain",
  TXT_CHARSET: "text/plain; charset=utf-8"
};

// we will likely load these from the api itself at a later date
export const ENDPOINTS = {
  INVITES: "/invites",
  PROJECTS: "/projects",
  PROJECT_ESTIMATES: "/projects/estimate",
  CONNECTIONS: "/connections",
  WORKSTATIONS: "/workstations",
  DATABASES: "/databases",
  CONTAINERS: "/containers",
  NODES: "/nodes",
  DISPLAY_GATEWAYS: "/displaygateways",
  VPN_GATEWAYS: "/virtualprivatenetworkgateways",
  SNOWFLAKES: "/snowflakes",
  USAGE: "/usage",
  USERS: "/users",
  IMAGES: "/images",
  IMAGE_ESTIMATES: "/images/estimate",
  SCHEDULES: "/schedules",
  INVOICES: "/invoices",
  SSH_KEYS: "/sshkeys",

  REFRESH_AUTHENTICATION: "/token/refresh",
  PASSWORD_RESET: "/users/password/reset",
  USERNAME_RECOVERY: "/users/username/recover",
  VERIFY: "/users/verify",
  VERIFICATION_RECOVERY: "/users/verification/recover"
};
